// Calendar-add URL builders for popular providers.
// The senior does NOT need to give LetterLifts their calendar credentials — we just
// hand them a pre-filled URL and let them save it in whichever calendar they use.

function _fmtDate(iso) {
  // deadline is YYYY-MM-DD. Google/Outlook want YYYYMMDD for all-day events.
  return (iso || "").replaceAll("-", "");
}

function _addDay(iso) {
  const d = new Date(iso + "T00:00:00");
  d.setDate(d.getDate() + 1);
  return d.toISOString().slice(0, 10);
}

function _describe(analysis, seniorName, shareUrl) {
  const who = seniorName?.trim() || "You";
  const action = (analysis.required_action || "Follow up on letter").replace(/[.!?;,: ]+$/, "");
  const parts = [
    `Requested by: ${who}`,
    `Action: ${action}`,
    `Deadline: ${analysis.deadline_text || analysis.deadline || "-"}`,
  ];
  if (analysis.amount) parts.push(`Amount: ${analysis.amount}`);
  if (analysis.sender_name) parts.push(`From: ${analysis.sender_name}`);
  if (analysis.deadline_confidence === "low" || analysis.deadline_confidence === "unclear") {
    parts.push("(!) Please double-check this date — the AI wasn't fully confident.");
  }
  if (shareUrl) parts.push(`Support link: ${shareUrl}`);
  return parts.join("\n");
}

function _title(analysis) {
  const action = (analysis.required_action || "Follow up on letter").replace(/[.!?;,: ]+$/, "");
  return `LetterLifts: ${action.slice(0, 80)}`;
}

/** Google Calendar “render” URL. Opens the compose view pre-filled. */
export function googleCalendarUrl({ analysis, seniorName, shareUrl, guests = [] }) {
  if (!analysis?.deadline) return null;
  const dates = `${_fmtDate(analysis.deadline)}/${_fmtDate(_addDay(analysis.deadline))}`;
  const params = new URLSearchParams({
    action: "TEMPLATE",
    text: _title(analysis),
    dates,
    details: _describe(analysis, seniorName, shareUrl),
  });
  if (analysis.sender_name) params.set("location", analysis.sender_name);
  guests.filter(Boolean).forEach((g) => params.append("add", g));
  return `https://calendar.google.com/calendar/render?${params.toString()}`;
}

/** Outlook (outlook.live.com / consumer). For work Office 365 use outlook.office.com. */
export function outlookCalendarUrl({ analysis, seniorName, shareUrl, office365 = false }) {
  if (!analysis?.deadline) return null;
  const start = analysis.deadline; // all-day, so YYYY-MM-DD
  const end = _addDay(analysis.deadline);
  const params = new URLSearchParams({
    path: "/calendar/action/compose",
    rru: "addevent",
    subject: _title(analysis),
    body: _describe(analysis, seniorName, shareUrl),
    startdt: start,
    enddt: end,
    allday: "true",
  });
  if (analysis.sender_name) params.set("location", analysis.sender_name);
  const host = office365 ? "outlook.office.com" : "outlook.live.com";
  return `https://${host}/calendar/0/deeplink/compose?${params.toString()}`;
}

/** Yahoo Calendar (bonus, still popular with 65+). */
export function yahooCalendarUrl({ analysis, seniorName, shareUrl }) {
  if (!analysis?.deadline) return null;
  const params = new URLSearchParams({
    v: "60",
    view: "d",
    type: "20",
    title: _title(analysis),
    st: _fmtDate(analysis.deadline) + "T000000",
    et: _fmtDate(_addDay(analysis.deadline)) + "T000000",
    desc: _describe(analysis, seniorName, shareUrl),
    dur: "allday",
  });
  return `https://calendar.yahoo.com/?${params.toString()}`;
}
